import { SiCodefactor } from "react-icons/si";
import { SummaryCards } from "../components/dashboard/summary-cards";
import { ChartCard } from "../components/dashboard/chart-card";
import {
  metrics,
  courseEnrollmentData,
  studentActivityData,
  courseDistributionData,
} from "../lib/mock-data";

export default function Dashboard() {
  return (
    <div className="min-h-screen bg-[#F5F5F5] p-8">
      <div className="mb-8 flex items-center gap-4">
        <SiCodefactor className="h-10 w-10 text-[#4CAF50]" />
        <div>
          <h1 className="text-2xl font-bold text-[#333333]">
            CodeVacado LMS Dashboard
          </h1>
          <p className="text-sm text-muted-foreground">
            Learning Management System Overview
          </p>
        </div>
      </div>

      <div className="space-y-8">
        <SummaryCards metrics={metrics} />

        <div className="grid gap-4 md:grid-cols-2">
          <ChartCard
            title="Course Enrollment Trends"
            data={courseEnrollmentData}
            type="area"
            dataKey="enrollments"
          />
          <ChartCard
            title="Daily Student Activity"
            data={studentActivityData}
            type="area"
            dataKey="active"
          />
        </div>

        <div className="grid gap-4 md:grid-cols-3">
          <ChartCard
            title="Course Distribution"
            data={courseDistributionData.data}
            type="pie"
            colors={courseDistributionData.colors}
          />
        </div>
      </div>
    </div>
  );
}
